import { createAction, createAsyncAction } from 'typesafe-actions';
import { AuthDto } from '../dtos/auth.dtos';

export const userLoggedIn = createAction('USER_LOGIN')<AuthDto>();
export const userLoginFail = createAction('USER_LOGIN_FAIL')<AuthDto>();

// TODO: Make sure all references are from here and not the account/login feature.
export const logoutActions = createAsyncAction(
  'LOGOUT_USER_REQUEST',
  'LOGOUT_USER_SUCCESS',
  'LOGOUT_USER_ERROR',
)<undefined, boolean, string>();
